import { baseUrl } from '../util';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import request from '@/utils/request';

export const getProductDetail = (handle: string, locale: string) => {
    const result = request(`${baseUrl(locale)}/product/detail/data?handle=${handle}&locale=${locale}`, {
        method: 'get',
        headers: {
            ...getDefaultHeader(locale),
        },
    });

    return result;
};
